// Utils
import editorStoreConnect from './editorStoreConnect';

// Selectors
import { getEditorId, getEditorState } from '../reducers/editorStoreSelector';
import { editorSelectionSave } from '../editorActions';

const mapEditorDispatchToProps = (dispatch) => ({
    dispatchGetEditorState: () => dispatch((_, getState) => getEditorState(getState())),
    dispatchGetEditorId: () => dispatch((_, getState) => getEditorId(getState())),
    dispatchSaveEditorSelection: ({ editorId, selection }) => dispatch(editorSelectionSave({ editorId, selection })),
    dispatchSaveCurrentSelection: () =>
        dispatch((_, getState) => {
            const state = getState();
            const editorId = getEditorId(state);
            const editorState = getEditorState(state);

            // NOTE: This is a hack fix to prevent errors when a Tiptap editor is being used instead of
            //  a Draft.js editor. In the future, Draft.js won't be used so there's no need to improve this.
            if (!editorState) return;

            const selection = editorState.getSelection();

            dispatch(editorSelectionSave({ editorId, selection }));
        }),
});

export default editorStoreConnect(null, mapEditorDispatchToProps);
